"use strict";
/* tslint:disable */

/* eslint-disable */

/**
 * Ampify Api
 * The Ampify API is used to power   * the Blocswave, Launchpad and Groovebox mobile apps   * Ampify Studio   * The FAST Plugins
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

var _inherits = require("/mnt/ramdisk/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/mnt/ramdisk/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/mnt/ramdisk/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _wrapNativeSuper = require("/mnt/ramdisk/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");

var _createClass = require("/mnt/ramdisk/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/mnt/ramdisk/node_modules/@babel/runtime/helpers/classCallCheck.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RequiredError = exports.BaseAPI = exports.COLLECTION_FORMATS = exports.BASE_PATH = void 0; // Some imports not used depending on template conditions
// @ts-ignore

var axios_1 = require("axios");

exports.BASE_PATH = "https://api.ampifymusic.com".replace(/\/+$/, "");
/**
 *
 * @export
 */

exports.COLLECTION_FORMATS = {
  csv: ",",
  ssv: " ",
  tsv: "\t",
  pipes: "|"
};
/**
 *
 * @export
 * @class BaseAPI
 */

var BaseAPI = /*#__PURE__*/_createClass(function BaseAPI(configuration) {
  var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : exports.BASE_PATH;
  var axios = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : axios_1.default;

  _classCallCheck(this, BaseAPI);

  this.basePath = basePath;
  this.axios = axios;

  if (configuration) {
    this.configuration = configuration;
    this.basePath = configuration.basePath || this.basePath;
  }
});

exports.BaseAPI = BaseAPI;
;
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */

var RequiredError = /*#__PURE__*/function (_Error) {
  _inherits(RequiredError, _Error);

  var _super = _createSuper(RequiredError);

  function RequiredError(field, msg) {
    var _this;

    _classCallCheck(this, RequiredError);

    _this = _super.call(this, msg);
    _this.field = field;
    _this.name = "RequiredError";
    return _this;
  }

  return _createClass(RequiredError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.RequiredError = RequiredError;